import "./statuscard.css";
import RefreshIcon from "@mui/icons-material/Refresh";

const StatusCard = (props) => {
  const style = {
    height: "170px",
  };

  return (
    <div
      className={`${props.data ? "status-card" : "status-card-load"} ${
        !props.data && "skeleton"
      } `}
      style={!props.data ? style : {border:props.k === 3 && "1px solid var(--main-color-green)",cursor:props.k === 3 && "pointer", height: props.k === 3 && "170px"}}
      onClick={()=>{props.k === 3 && props.setWalletLoadPopup(true)}}
    >
      {props.data && props.k !== 3 && (
        <div className="Refresh_icon">
          <RefreshIcon onClick={() => props.refreshDashBoard()} />
        </div>
      )}

      {props.data && (
        <>
          <div className="status-card__icon">
            <img src={props.icon} style={{ color: "red!important" }} />
          </div>
          <div className="status-card__info">
            <h4>{props.count}</h4>
            <span className={`${props.k === 3 && "primary_Btn"}`} style={{padding:"5px 15px"}} >{props.title}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default StatusCard;
